function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  x: "-15.2%",
  y: "-15.2%",
  width: "130.5%",
  height: "130.5%",
  filterUnits: "objectBoundingBox",
  id: "filter-1"
}, /*#__PURE__*/React.createElement("feOffset", {
  dx: 0,
  dy: 2,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 7.5,
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.980392157   0 0 0 0 0.501960784   0 0 0 0 0.447058824  0 0 0 1 0",
  type: "matrix",
  in: "shadowBlurOuter1",
  result: "shadowMatrixOuter1"
}), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
  in: "shadowMatrixOuter1"
}), /*#__PURE__*/React.createElement("feMergeNode", {
  in: "SourceGraphic"
}))), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "63.3637214%",
  y1: "50%",
  x2: "-29.4735258%",
  y2: "0%",
  id: "linearGradient-2"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FA8072",
  stopOpacity: 0.610686189,
  offset: "0%"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "offset",
  values: "1;0",
  repeatCount: 1,
  fill: "freeze",
  dur: "1.6s",
  repeatDur: "indefinite",
  begin: "lastCycle1.end"
}), /*#__PURE__*/React.createElement("animate", {
  id: "lastCycle1",
  attributeName: "offset",
  values: "0;1",
  repeatCount: 1,
  fill: "freeze",
  dur: "1.2s",
  repeatDur: "indefinite",
  begin: "0s;lastCycle2.end"
})), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#000000",
  stopOpacity: 0,
  offset: "100%"
}, /*#__PURE__*/React.createElement("animate", {
  id: "lastCycle2",
  attributeName: "offset",
  values: "1;0",
  repeatCount: 1,
  from: "100%",
  to: "0%",
  fill: "freeze",
  dur: "1.8s",
  repeatDur: "indefinite",
  begin: "lastCycle1.end"
}))), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "52.6492955%",
  y1: "39.9373834%",
  x2: "14.8367758%",
  y2: "100%",
  id: "linearGradient-3"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FA8072",
  stopOpacity: 0.696623689,
  offset: "0%"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "offset",
  values: "1;0",
  repeatCount: 1,
  fill: "freeze",
  dur: "1.6s",
  repeatDur: "indefinite",
  begin: "lastCycle1.end"
}), /*#__PURE__*/React.createElement("animate", {
  id: "lastCycle1",
  attributeName: "offset",
  values: "0;1",
  repeatCount: 1,
  fill: "freeze",
  dur: "1.2s",
  repeatDur: "indefinite",
  begin: "0s;lastCycle2.end"
})), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#000000",
  stopOpacity: 0,
  offset: "100%"
}, /*#__PURE__*/React.createElement("animate", {
  id: "lastCycle2",
  attributeName: "offset",
  values: "1;0",
  repeatCount: 1,
  from: "100%",
  to: "0%",
  fill: "freeze",
  dur: "1.8s",
  repeatDur: "indefinite",
  begin: "lastCycle1.end"
}))), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "95.4797278%",
  y1: "70.0974961%",
  x2: "37.3966695%",
  y2: "-12.486231%",
  id: "linearGradient-4"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FA8072",
  stopOpacity: 0,
  offset: "0%"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "offset",
  values: "1;0",
  repeatCount: 1,
  fill: "freeze",
  dur: "1.6s",
  repeatDur: "indefinite",
  begin: "lastCycle1.end"
}), /*#__PURE__*/React.createElement("animate", {
  id: "lastCycle1",
  attributeName: "offset",
  values: "0;1",
  repeatCount: 1,
  fill: "freeze",
  dur: "1.2s",
  repeatDur: "indefinite",
  begin: "0s;lastCycle2.end"
})), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FA8072",
  offset: "100%"
}, /*#__PURE__*/React.createElement("animate", {
  id: "lastCycle2",
  attributeName: "offset",
  values: "1;0",
  repeatCount: 1,
  from: "100%",
  to: "0%",
  fill: "freeze",
  dur: "1.8s",
  repeatDur: "indefinite",
  begin: "lastCycle1.end"
}))), /*#__PURE__*/React.createElement("path", {
  d: "M109.314353,77.0019892 C108.368894,76.9649091 107.480644,77.4485628 107.00824,78.2576727 L71.3562627,138.661284 C70.888507,139.439313 70.8808625,140.405489 71.3362502,141.190632 C71.7916379,141.975775 72.6396843,142.458553 73.5563476,142.45452 L144.807289,142.45452 C145.723952,142.458553 146.571998,141.975775 147.027386,141.190632 C147.482774,140.405489 147.475129,139.439313 147.007374,138.661284 L111.40841,78.2576727 C110.973939,77.513201 110.18404,77.0395444 109.314353,77.0019892 Z M108.731714,83.6403162 L140.681818,137.711462 L76.7272727,137.711462 L108.731714,83.6403162 Z M109.181818,99.7667984 C107.073094,99.7667984 105.363636,101.511143 105.363636,103.662902 L109.181818,121.58498 L113,103.662902 C113,101.511143 111.290542,99.7667984 109.181818,99.7667984 Z M109.181818,124.43083 C107.073094,124.43083 105.363636,126.129689 105.363636,128.225296 C105.363636,130.320904 107.073094,132.019763 109.181818,132.019763 C111.290543,132.019763 113,130.320904 113,128.225296 C113,126.129689 111.290543,124.43083 109.181818,124.43083 Z",
  id: "path-5"
}), /*#__PURE__*/React.createElement("filter", {
  x: "-48.5%",
  y: "-53.5%",
  width: "196.9%",
  height: "213.1%",
  filterUnits: "objectBoundingBox",
  id: "filter-6"
}, /*#__PURE__*/React.createElement("feOffset", {
  dx: 0,
  dy: 2,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 12,
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.980392157   0 0 0 0 0.501960784   0 0 0 0 0.447058824  0 0 0 0.690395542 0",
  type: "matrix",
  in: "shadowBlurOuter1"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Kronos_Style-guide_3",
  transform: "translate(-75.000000, -2019.000000)",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-18",
  transform: "translate(100.000000, 1383.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "200px_4",
  transform: "translate(0.000000, 661.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "circle-copy-6",
  filter: "url(#filter-1)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M110,0 C170.725644,0.0619491876 219.938051,49.2743562 220,110 C220,170.751322 170.751322,220 110,220 C49.2486775,220 0,170.751322 0,110 C0,49.2486775 49.2486775,0 110,0 Z M110,0.916666667 C49.7549385,0.916666667 0.916666667,49.7549385 0.916666667,110 C0.916666667,170.245061 49.7549385,219.083333 110,219.083333 C170.245061,219.083333 219.083333,170.245061 219.083333,110 C219.0219,49.7804033 170.219597,0.978099611 110,0.916666667 Z",
  id: "Combined-Shape",
  fill: "url(#linearGradient-2)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M110,22.9166667 C158.094797,22.9166667 197.083333,61.905203 197.083333,110 C197.083333,158.094797 158.094797,197.083333 110,197.083333 C61.905203,197.083333 22.9166667,158.094797 22.9166667,110 C22.9657098,61.925532 61.925532,22.9657098 110,22.9166667 Z M110,23.6423611 C62.305993,23.6423611 23.6423611,62.305993 23.6423611,110 C23.6423611,157.694007 62.305993,196.357639 110,196.357639 C157.694007,196.357639 196.357639,157.694007 196.357639,110 C196.309004,62.3261526 157.673847,23.6909955 110,23.6423611 Z",
  id: "Combined-Shape",
  fill: "url(#linearGradient-3)",
  transform: "translate(110.000000, 110.000000) scale(1, -1) translate(-110.000000, -110.000000) "
}), /*#__PURE__*/React.createElement("path", {
  d: "M110,45.8333333 C145.423292,45.8694704 174.13053,74.5767078 174.166667,110 C174.166667,145.438271 145.438271,174.166667 110,174.166667 C74.5617286,174.166667 45.8333333,145.438271 45.8333333,110 C45.8333333,74.5617286 74.5617286,45.8333333 110,45.8333333 Z M110,46.75 C75.0679896,46.75 46.75,75.0679896 46.75,110 C46.75,144.93201 75.0679896,173.25 110,173.25 C144.93201,173.25 173.25,144.93201 173.25,110 C173.214379,75.0827548 144.917245,46.7856208 110,46.75 Z",
  id: "Combined-Shape",
  fill: "url(#linearGradient-4)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Shape"
}, /*#__PURE__*/React.createElement("use", {
  fill: "black",
  fillOpacity: 1,
  filter: "url(#filter-6)",
  xlinkHref: "#path-5"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#FA8072",
  xlinkHref: "#path-5"
}))))));

var SvgWarning = function SvgWarning(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "270px",
    height: "270px",
    viewBox: "0 0 270 270",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWarning, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/warning.d42e2943.svg";
export { ForwardRef as ReactComponent };